import AdminError from '@components/admin/AdminError'

const AdminServerError = () => <AdminError code={500} />

export default AdminServerError
